// @flow

export const TREE = 'soilJobsModule'
export const TABLE_BRANCH = 'table'
export const OPERATIONS_BRANCH = 'operations'
export const FILTERS_BRANCH = 'filters'
export const FILTER_STATUS = 'status'
export const FILTER_START_DATE = 'startDate'
export const FILTER_END_DATE = 'endDate'
export const FILTER_ASSIGN_TO = 'assignTo'
export const FILTER_SEASON = 'season'

// Format
export const DATE_FORMAT = 'MMM DD YYYY'

// Operations
export const ADD_SOILJOB = '@soilJobsModule/ADD_SOILJOB'
export const EDIT_SOILJOB = '@soilJobsModule/EDIT_SOILJOB'
export const ADD_TABLE_SOILJOB = '@soilJobsModule/ADD_TABLE_SOILJOB'
export const EDIT_TABLE_SOILJOB = '@soilJobsModule/EDIT_TABLE_SOILJOB'
export const DELETE_TABLE_SOILJOB = '@soilJobsModule/DELETE_TABLE_SOILJOB'

export const SELECT_SOIL_JOB = '@soilJobsModule/SELECT_SOIL_JOB'

// Routes
export const HEFTY_SHIPPING_PDF_ROUTE = '/hefty/shippingpdf'
export const REPORTS_LAB_RESULTS_ROUTE = '/reports/labResult'
